import React from 'react';
import { IExternalDataItem, ExternalDataItemID } from '../../interfaces';
import { MACROECONOMICS_LABEL } from '../../constants';
import ExternalDataItem from './ExternalDataItem';
import GQFlag from '../GQFlag';
import classNames from 'classnames';
import ExternalDataDropdownSearch from '../GQDropDown/ExternalDataDropDownSearch';
import { globalRiskColor, translateGlobalIndex } from '../../utils/renderUtils';
import { isEmpty } from 'lodash/fp';
import { FGIcons, FGStack, FGTypography } from '@fg/design-system';
import cx from 'classnames';

interface IExternalDataPopupProps {
    itemsList: IExternalDataItem[];
    selectedList: number[];
    dropDownList: any[];
    dropDownSelectedItems: any[];
    onDropDownItemClicked: (id: any) => void;
     macroeconomicsSelectedIndicator?: string;
}
interface IExternalDataPopupState {
    showDropDown: boolean;
}

class ExternalDataPopup extends React.Component<
    IExternalDataPopupProps,
    IExternalDataPopupState
> {
    constructor(props: IExternalDataPopupProps) {
        super(props);
        this.state = {
            showDropDown: false,
        };
    }

    public render() {
        const { itemsList, selectedList, macroeconomicsSelectedIndicator } = this.props;
        const isCommoditySelected = selectedList[0] === ExternalDataItemID.COMMODITY;
        const isMacroeconomicsSelected = selectedList[0] === ExternalDataItemID.MACROECONOMICS;
        const isMacroeconomicsSelectedNoSub = isMacroeconomicsSelected && macroeconomicsSelectedIndicator === '';
        const showSubcategoryBorder = isCommoditySelected || isMacroeconomicsSelectedNoSub;

        const selectedExternalData = selectedList[0];
        const dropdownViewKey = `${selectedExternalData}:${macroeconomicsSelectedIndicator || ''}`;
        return (
            <div className="external-data-popup-content">
                <div className={cx("external-data-top-content", { "subcategory-border": showSubcategoryBorder })}>
                    {itemsList &&
                        itemsList
                            .filter(
                                item =>
                                    isEmpty(selectedList) ||
                                    (!isEmpty(selectedList) &&
                                        selectedList.includes(item.id))
                            )
                            .map(item => {
                                const displayName = item.name === MACROECONOMICS_LABEL
                                    ? (macroeconomicsSelectedIndicator || MACROECONOMICS_LABEL)
                                    : item.name;
                                return (
                                    <ExternalDataItem
                                        name={displayName}
                                        id={item.id}
                                        selectedList={selectedList}
                                        checked={selectedList.includes(item.id)}
                                        key={item.id}
                                        onclick={item.onClick}
                                    />
                                );
                            })}
                </div>
                {!isEmpty(selectedList) && (
                    <ExternalDataDropDown
                        key={dropdownViewKey}
                        list={this.props.dropDownList}
                        selectedList={this.props.dropDownSelectedItems}
                        onClick={this.onDropDownItemClicked}
                        selectedExternalData={selectedExternalData}
                        changeDropDownState={this.changeDropDownState}
                        showDropDown={this.state.showDropDown}
                    />
                )}
            </div>
        );
    }

    private onDropDownItemClicked = (id: any) => {
        this.changeDropDownState();
        this.props.onDropDownItemClicked(id);
    };
    private changeDropDownState = () => {
        this.setState({
            showDropDown: !this.state.showDropDown,
        });
    };
}

interface IExternalDataDropDown {
    list: any[];
    onClick?: (id: any) => any;
    selectedList: any[];
    selectedExternalData: number;
    showDropDown: boolean;
    changeDropDownState: () => any;
}

const ExternalDataDropDown = (props: IExternalDataDropDown) => {
    let dropDown;
    let selectedItem;
    let showSearchItem = true;
    let useAutoHeight = false;
    if (props.selectedExternalData === 2) {
        showSearchItem = true;
        useAutoHeight = false;
        dropDown = props.list.filter(item => !!item.currency_code).map(item => {
            const isSelected = props.selectedList.includes(item.id);
            return (
                <div
                    key={item.id}
                    className={classNames(['drop-down-item'], {
                        selected: isSelected,
                    })}
                    onClick={() => props.onClick(item.id)}
                    data-searchable-text={`${item.name} (${item.currency_code})`}>
                    <GQFlag countryId={item.id} className="flag-icon-squared" />
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flex: 1,
                            marginLeft: 6,
                        }}>
                        <span>
                            {item.name} ({item.currency_code})
                        </span>
                        {isSelected && <FGIcons icon="Check2" size={12} />}
                    </div>
                </div>
            );
        });
        const selected = props.list.filter(
            item => item.id === props.selectedList[0]
        );
        selectedItem =
            props.selectedList.length > 0 ? (
                <div>
                    <GQFlag
                        countryId={selected[0].id}
                        className="flag-icon-squared"
                    />
                    <span>{selected[0].abbreviation_short}</span>{' '}
                </div>
            ) : (
                <div className="select-from-list">select currency</div>
            );
    } else if (props.selectedExternalData === 4) {
        showSearchItem = false;
        useAutoHeight = true;
        dropDown = props.list.map(item => {
            const isSelected = props.selectedList.includes(item);
            return (
                <div
                    key={item}
                    className={classNames(['drop-down-item'], {
                        selected: props.selectedList.includes(item),
                    })}
                    onClick={() => props.onClick(item)}
                    data-searchable-text={translateGlobalIndex[item]}>
                    <span
                        style={{
                            marginRight: 8,
                            height: 6,
                            width: 6,
                            backgroundColor: globalRiskColor(item),
                            borderRadius: '50%',
                        }}
                    />
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flex: 1,
                        }}>
                        <span>{translateGlobalIndex[item]}</span>
                        {isSelected && <FGIcons icon="Check2" size={12} />}
                    </div>
                </div>
            );
        });
        const selected = props.list.filter(
            item => item === props.selectedList[0]
        );
        selectedItem =
            props.selectedList.length > 0 ? (
                <div>
                    <span
                        style={{
                            marginLeft: '4px',
                            marginBottom: '-1px',
                            marginRight: '5px',
                            height: '6px',
                            width: '6px',
                            backgroundColor: globalRiskColor(selected[0]),
                            borderRadius: '50%',
                            display: 'inline-block',
                        }}
                    />
                    <span>{translateGlobalIndex[selected[0]]}</span>
                </div>
            ) : (
                <div className="select-from-list">select commodity</div>
            );
    } else if (props.selectedExternalData === 5) {
        if (props.list.length === 2) {
            showSearchItem = false;
            useAutoHeight = true;
        }
        dropDown = props.list
            .filter(item => {
                if (typeof item === 'string') return true;
                return !!item.currency_code;
            })
            .map(item => {
                const isString = typeof item === 'string';
                const key = isString ? item : item.id;
                const isSelected = props.selectedList.includes(key);
                const label = isString ? (translateGlobalIndex[item] || item) : `${item.name}`;

                return (
                    <div
                        key={key}
                        className={classNames(['drop-down-item'], { selected: isSelected })}
                        onClick={() => props.onClick(key)}
                        data-searchable-text={label}
                    >
                        {isString ? (
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: 1 }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span>{label}</span>
                                    <FGIcons icon="RightArrow" />
                                </div>
                                {isSelected && <FGIcons icon="Check2" size={12} />}
                            </div>
                        ) : (
                            <FGStack justifyContent="space-between" alignItems="center" style={{ flex: 1 }}>
                                <FGStack alignItems="center" gap={6}>
                                    <GQFlag countryId={item.id} className="flag-icon-squared" />
                                    <FGTypography tag="span">{label}</FGTypography>
                                </FGStack>
                                {isSelected && <FGIcons icon="Check2" size={12} />}
                            </FGStack>
                        )}
                    </div>
                );
            });
    }
    return (
        <ExternalDataDropdownSearch dropDownContent={dropDown} selectedItem={selectedItem} showSearchItem={showSearchItem} useAutoHeight={useAutoHeight} />
    );
};

export default ExternalDataPopup;
